export const areStringArraysEqual = (
	current?: readonly string[],
	next?: readonly string[],
): boolean => {
	if (current === next) {
		return true;
	}

	if (!current || !next || current.length !== next.length) {
		return false;
	}

	return current.every((value, index) => value === next[index]);
};
